import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11a582c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-list" }
const _hoisted_2 = { class: "sync-table" }

import { t } from '@/plugins/i18n'
import { ref, reactive, computed, nextTick, toRaw } from 'vue'
import STable from '@/components/Table/index.vue'
import SSearch from './Search.vue'
import { setNoEmptyForm } from '@/util/common'
import { ElMessage } from 'element-plus'
import { useStore } from 'vuex'
import { delProduct, amazonPage } from '@/apis/order'
import { syncAllGoods } from '@/apis/associated'
import { confirmApiUnbind } from '@/util/useConfirm'
import { useRequest } from '@/util/useLoading'
import BatchSearch from '@/components/BatchSearch/index.vue'
import bus from '@/util/useBus'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const tableConfig = {
  showHandler: true,
  setHeight: true,
  handlerConfig: { label: ' ' }
}

const columns = [
  {
    label: t('商品信息'),
    prop: 'shopOrderInfo',
    slotName: 'shopOrderInfo',
    width: 400
  },
  {
    label: t('Amazon sku'),
    prop: 'amazonMsku',
    align: 'center'
  },
  {
    label: t('fnsku'),
    prop: 'amazonFnsku',
    align: 'center'
  },
  {
    label: t('asin'),
    prop: 'amazonAsin',
    align: 'center'
  }
]

const [syncLoading, syncApi] = useRequest(syncAllGoods)
const setSyncProduct = async () => {
  const unbind = await confirmApiUnbind()
  if (unbind) return
  syncApi().then((res: any) => {
    if (res.success) {
      ElMessage.success(t('同步商品进行中，请等待1-3分钟'))
      setTimeout(() => refreshTable(true), 1000)
    }
  })
}

const delOrder = (row: any) => {
  row.delLoading = true
  delProduct({ amazonMsku: row.amazonMsku }).then((res: any) => {
    if (res.success) {
      ElMessage.success(t('修改成功'))
      refreshTable()
    }
  }).finally(() => { row.delLoading = false })
}

const STableRef = ref()
const refreshTable = (type?: boolean) => {
  if (type) {
    pageData.value = {
      page: 1,
      limit: 30
    }
  }
  nextTick(() => {
    STableRef.value && STableRef.value.getData()
  })
}
const searchForm: any = ref({})

const store = useStore()
const customerShopId = store.getters.curShop

const filterData = computed(() => {
  const data = { ...toRaw(searchForm.value) }
  data.amazonMskuList = data.amazonMskuList ? [data.amazonMskuList] : undefined
  return {
    customerShopId,
    ...setNoEmptyForm({
      ...data
    })
  }
})

const pageData = ref({
  page: 1,
  limit: 30
})

const batchSearchParams = ref({})
const isBatchSearch = ref(false) // 是否批量搜索
bus.on('batchSearch', (params: any) => {
  isBatchSearch.value = true
  batchSearchParams.value = {
    ...params,
    customerShopId
  }
  refreshTable(true)
})
const search = () => {
  isBatchSearch.value = false
  refreshTable(true)
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_table_button = _resolveComponent("table-button")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SSearch, {
      form: searchForm.value,
      "onUpdate:form": [
        _cache[0] || (_cache[0] = ($event: any) => ((searchForm).value = $event)),
        search
      ]
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            style: {"margin-left":"6px"},
            type: "primary",
            loading: _unref(syncLoading),
            onClick: setSyncProduct
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('同步商品')), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      _: 1
    }, 8, ["form"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(STable, {
        ref: (_value, _refs) => {
          _refs['STableRef'] = _value
          STableRef.value = _value
        },
        "page-data": pageData.value,
        "onUpdate:page-data": _cache[1] || (_cache[1] = ($event: any) => ((pageData).value = $event)),
        api: _unref(amazonPage),
        filterData: isBatchSearch.value ? batchSearchParams.value : _unref(filterData),
        columns: columns,
        "table-config": tableConfig
      }, {
        shopOrderInfo: _withCtx(({row}) => [
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(row.productName ?? '') + "/", 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((row.productProp || '').split(';'), (prop) => {
              return (_openBlock(), _createElementBlock("span", { key: prop }, _toDisplayString(prop.replace(/[+-]?\d+:[+-]?\d+:/, '')), 1))
            }), 128))
          ])
        ]),
        handler: _withCtx(({scope}) => [
          _createVNode(_component_el_popconfirm, {
            "popper-class": "pay-pop",
            title: _unref(t)('是否删除'),
            onConfirm: ($event: any) => (delOrder(scope.row))
          }, {
            reference: _withCtx(() => [
              _createVNode(_component_table_button, {
                title: _unref(t)('删除'),
                loading: scope.row.delLoading
              }, null, 8, ["title", "loading"])
            ]),
            _: 2
          }, 1032, ["title", "onConfirm"])
        ]),
        _: 1
      }, 8, ["page-data", "api", "filterData"])
    ]),
    _createVNode(BatchSearch)
  ]))
}
}

})